/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Mobile = createReactComponent("mobile", "Mobile", [["path", { "d": "M16.286 3H7.714C6.768 3 6 3.806 6 4.8v14.4c0 .994.768 1.8 1.714 1.8h8.572c.947 0 1.714-.806 1.714-1.8V4.8c0-.994-.767-1.8-1.714-1.8M10.5 6h3", "key": "svg-0" }]]);

export { Mobile as default };
//# sourceMappingURL=Mobile.js.map
